angular.module('xcLogin').controller('FatalErrorController', function($scope, $state, $uibModalInstance, errorMessage, XucLink, CtiProxy, XucPhoneState, showSwitchModal, showLogoutButton, switchConfirmationMessage, $uibModalStack) {
  $scope.errorMessage = errorMessage;
  $scope.showSwitchModal = showSwitchModal;
  $scope.showLogoutButton = showLogoutButton;
  $scope.switchConfirmationMessage = switchConfirmationMessage;

  var logout = function() {
    if (CtiProxy.isUsingWebRtc()) {
      XucPhoneState.getCalls().forEach(function(call) {
        CtiProxy.hangup(call.uniqueId);
      });
    }
    CtiProxy.stopUsingWebRtc();
    XucLink.logout();
    if(errorMessage === 'CTI_SOCKET_CLOSED_WHILE_USING_WEBRTC') {
      $state.go('login', {error: 'LinkClosed'});
    } else {
      $state.go('login', {error: 'Logout'});
    }
    $uibModalStack.dismissAll();
  };

  $uibModalInstance.result.then(function (logoutReturnState ) {
    if (logoutReturnState === true) {
      logout();
    }
  }, function (logoutReturnState) {
    if (logoutReturnState === true) {
      logout();
    }
  });

  $scope.close = function(state) {
    $uibModalInstance.close(state);
    if (state === true) {
      logout();
    }
  };
});

